import React from 'react';
import { Type, Copy, Check, Star } from 'lucide-react';
import { toast } from 'sonner';
import { useT } from '@/lib/i18n';

const TitleSuggestions = ({ titles = [] }) => {
  const { lang } = useT();
  const [copiedIdx, setCopiedIdx] = React.useState(null);
  const copy = async (txt, idx) => {
    try {
      await navigator.clipboard.writeText(txt);
      setCopiedIdx(idx);
      toast.success(lang === 'fr' ? 'Titre copié' : 'Title copied');
      setTimeout(() => setCopiedIdx(null), 1500);
    } catch { toast.error('Copy failed'); }
  };
  return (
    <div className="rounded-xl border border-white/10 bg-[#0a0a0a] p-4" data-testid="title-suggestions">
      <div className="flex items-center gap-2 mb-3">
        <Type className="w-3.5 h-3.5 text-[#D4FF00]" />
        <span className="font-heading font-bold text-xs sm:text-sm uppercase tracking-wider">
          {lang === 'fr' ? 'Titres suggérés' : 'Title suggestions'}
        </span>
      </div>
      <div className="space-y-2">
        {titles.length === 0 ? (
          <span className="text-zinc-600 text-sm italic">—</span>
        ) : titles.map((title, idx) => {
          const isBest = idx === 0;
          return (
            <div
              key={`${title}-${idx}`}
              className={`flex items-center justify-between gap-3 p-3 rounded-lg border ${
                isBest ? 'border-[#D4FF00]/30 bg-[#D4FF00]/[0.04]' : 'border-white/5 bg-white/[0.02]'
              }`}
              data-testid={`title-suggestion-${idx}`}
            >
              <div className="flex items-center gap-2 min-w-0 flex-1">
                {isBest ? (
                  <Star className="w-3.5 h-3.5 text-[#D4FF00] shrink-0 fill-[#D4FF00]" />
                ) : (
                  <span className="text-[10px] font-mono text-zinc-600 w-5 text-center shrink-0">{String(idx).padStart(2, '0')}</span>
                )}
                <p className={`text-sm leading-snug truncate ${isBest ? 'text-white font-medium' : 'text-zinc-300'}`}>{title}</p>
              </div>
              <button
                onClick={() => copy(title, idx)}
                className="p-1.5 rounded-md hover:bg-white/10 text-zinc-400 hover:text-white transition-colors shrink-0"
                data-testid={`title-copy-${idx}`}
                title="Copy"
              >
                {copiedIdx === idx ? <Check className="w-3.5 h-3.5 text-[#D4FF00]" /> : <Copy className="w-3.5 h-3.5" />}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TitleSuggestions;
